module.exports = __webpack_public_path__ + "img/gywmj1.6637326c.png";